export const newMenuWidth = 280;
